/* ==========================================================================
   MortgagePath — site-wide promotion feature flags.
   --------------------------------------------------------------------------
   Single source of truth for switching the £100 Homebuyer Cashback promotion
   on or off. Nothing is deleted while disabled — flipping the flag back to
   `true` fully restores the promotion (dedicated page, navigation entry,
   footer link, homepage banner, all in-journey prompts, the privacy-policy
   disclosure, and prerender/sitemap indexing) with no rebuilding of code.

   REVERSIBLE TOGGLE:
     cashbackPromotionEnabled = true   → promotion fully live
     cashbackPromotionEnabled = false  → promotion hidden / page unavailable

   NOTE: while disabled, the /cashback <url> entry in public/sitemap.xml is
   moved into the excluded/noindex comment block. When re-enabling, restore
   that single <url> entry (see the comment in public/sitemap.xml).

   CommonJS module.exports so BOTH the React app (ESM import interop) AND the
   build-time prerender script (require) read the same flag.
   ========================================================================== */
const cashbackPromotionEnabled = false;

module.exports = { cashbackPromotionEnabled };
